export const DEFINE_MODULOS = 'DEFINE_MODULOS'